export default __webpack_public_path__ + "static/media/box.ea8258db.svg";